// extracted by mini-css-extract-plugin
module.exports = {"_container":"Abholwerk__container__1-MkH","_notificationLink":"Abholwerk__notificationLink__Ug7H6","linkButton":"Abholwerk_linkButton__1fnTz"};